<template>
	<div class="meeting-details">
		<div class="banner-show">
			<div class="cover">
				<van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
					<van-swipe-item>
					  <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_banner.png" alt="">
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<div class="buttons">
			<div class="one">
                <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_1.png" @click="skip(1183)"/>
            </div>
			<div class="grid">
                <div>
                   <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_2.png" @click="skip(1188)"/>
                </div>
                <div class="half">
                   <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_3.png" @click="skip(1186)"/>
                </div>
                <div class="half">
                    <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_4.png" @click="skip(1184)"/>
                </div>
            </div>
			<div class="grid">
                <div>
                   <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_5.png" @click="skip(1186)"/>
                </div>
                <div class="half">
                   <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_7.png" @click="skip(1404)" style="height:98%;"/>
                </div>
                <div class="half">
                    <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_8.png" @click="skip(1402)"/>
                    <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_9.png" @click="skip(100)"/>
                </div>
            </div>
			 <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_6.png" @click="skip(1185)" style="height: 65.5%;"/>
                <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_button_10.png" @click="skip(1342)"/>
            </div>
        </div>
        <img src="//xgzx.admin.talkmed.com/image/UI/TECross2023_bottom.png" style="width:100%;display:block;"/>
	</div>
</template>
<script>
	// import Register from "../../components/Users/Register.vue"
	import {MeetingButtons,MeetingsCarousel,MeetingsDetails,companyImages} from '../../config/interface.js'
	export default{
		data(){
			return{
				meetingButton:{},    //会议按钮
                swiperImg:[],
                meeting_id:'385'
			}
		},
		beforeRouteEnter(to, from, next) {
            //  修复iOS版微信HTML5 History兼容性问题
            if (to.path !== location.pathname) {
               
                location.assign(to.fullPath)
            } else {
                next()
            }
        },
		mounted(){
			this.getMeetingButtons(this.meeting_id);
			this.getMeetingCarousel();
            this.getMeetingDetails();
		},
		methods:{
			getImages(){
				const url=companyImages;
				let params={
					meeting_id:this.meeting_id,
				}
				const method="POST";
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.images=res.data;
					}
				})
			},
			//会议轮播
			getMeetingCarousel(){
				const url=MeetingsCarousel;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
				})
			},
			clickSwiperImg(item){
				window.location.href=item.link;
			},
			//会议按钮
			getMeetingButtons(id){
				const url=MeetingButtons;
				const method='POST';
				let params={
					meeting_id:id
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						for(let i in data){
							this.meetingButton[data[i].id]=data[i].url
						}
					}
				})
			},
			//会议详情
			getMeetingDetails(){
				const url=MeetingsDetails;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						document.title=data.name;
						// this.meeting_dates=data.meeting_dates;
						//微信浏览器  请求jsdk
						if(common.is_weixin()){
							common.wxShare(data.name,data.title,data.shareimg);
						}
					}
				})
			},
            skip(id){
             	if(this.meetingButton[id]){
					window.location.href=this.meetingButton[id];
                }
            }
		}
	}
</script>
<style lang="scss" scoped>
	.meeting-details{
        background: white;
		.banner-show{
			width:100%;
			// height:210px;
			padding:0px;
			.cover{
				width:100%;
				// height:210px;
				// margin-bottom:14px;
				img{
					width:100%;
					// height:210px;
				}
			}
		}
		.buttons{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 10px 25px 20px;
            .one{
                width: 32%;
            }
            .two{
                width:65%;
            }
            img{
                width: 100%;
            }
            .grid{
                width:66%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .half{
                    width: 48.5%;
                }
            }
        }
		
	}
</style>


// WEBPACK FOOTER //
// src/pages/TECross2023/index.vue